import { render, staticRenderFns } from "./ImplantSidePanel.vue?vue&type=template&id=12a5b88e&scoped=true&"
import script from "./ImplantSidePanel.vue?vue&type=script&lang=js&"
export * from "./ImplantSidePanel.vue?vue&type=script&lang=js&"
import style0 from "./ImplantSidePanel.vue?vue&type=style&index=0&id=12a5b88e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a5b88e",
  null
  
)

export default component.exports